// extracted by mini-css-extract-plugin
export var aboutUsSection = "about-module--aboutUsSection--iSZ+3";
export var contactUsSection = "about-module--contactUsSection--HrWbW";
export var contactUsText = "about-module--contactUsText--NQE8J";
export var employeeProfiles = "about-module--employeeProfiles--4iF1A";
export var paragraph = "about-module--paragraph--nl8sC";
export var separator = "about-module--separator--nuJg5";
export var title = "about-module--title--2h5ck";